// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q61rL","field":"styles_field__3uzw5","fieldCol":"styles_fieldCol__1wTXu","diffCol":"styles_diffCol__1Z2rV","diff":"styles_diff__10_sv"};